import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {CloneObject} from '../../../utils/helpers';
import DatePickerCustom from '../../common/DatePickerCustom';
import InputEntidad from '../../common/InputEntidad';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {FormError, InputSubTasa, InputTasa} from '../../common';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormLabel} from "../../common";

const LadoTerrenoServicioModal = (props) => {

    const entityInit = {
        id: 0,
        idLadoTerreno: 0,
        idTasa: 0,
        idSubTasa: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta
        })
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        fechaDesde: null,
        fechaHasta: null
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTasa = parseInt(formValues.idTasa);
        row.idSubTasa = parseInt(formValues.idSubTasa);
        row.fechaDesde = formValues.fechaDesde;
        row.fechaHasta = formValues.fechaHasta;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaDesde === null) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title="Servicio del lado del terreno"
                tipName={TIPS.NAME.MODALS.LADO_TERRENO_SERVICIO_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idTasa')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idSubTasa" required>Sub tasa</FormLabel>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idSubTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    idTasa={formValues.idTasa}
                                                />
                                                <FormError message={errorOf('idSubTasa')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="fechaDesde" required>Fecha
                                                    desde</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaDesde')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="fechaHasta" className="form-label">Fecha
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaHasta"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaDesde}
                                                />
                                                <FormError />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de servicio de lado del terreno"
                                            processKey={props.processKey}
                                            entidad="LadoTerrenoServicio"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

LadoTerrenoServicioModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

LadoTerrenoServicioModal.defaultProps = {
    disabled: false
};

export default LadoTerrenoServicioModal;